export const FETCH_LISTING_URL = `${process.env.REACT_APP_API_URL}/listings`;
export const CREATE_LISTING_URL = `${process.env.REACT_APP_API_URL}/listings/create`;
export const UPDATE_LISTING_URL = `${process.env.REACT_APP_API_URL}/listings`;
export const DELETE_LISTING_URL = `${process.env.REACT_APP_API_URL}/listings`;
export const UPDATE_LISTING_ASSET_LISTING_URL = `${process.env.REACT_APP_API_URL}/listings/asset_listing`;
